import { TaxEnum } from '@core/enums';
import { MenuItemProcessingRule } from '../interfaces';

export const menuItemRemoveInclusiveTaxesRule: MenuItemProcessingRule = context => ({
	...context,
	items: context.items.map(item => {
		const inclusiveTaxes = item.impuestos?.filter(tax => tax.tipo === TaxEnum.Inclusive) ?? [];
		const fixedTaxes = inclusiveTaxes
			.filter(tax => !tax.esPorcentaje)
			.reduce((total, tax) => total + BigInt(tax.valor ?? 0), 0n);
		const percentageTaxes = inclusiveTaxes
			.filter(tax => tax.esPorcentaje)
			.reduce((total, tax) => total + BigInt(tax.valor ?? 0), 0n);
		const removeInclusiveTaxes = (price: bigint | string | number | undefined | null): bigint => {
			if (price === undefined || price === null || price === '') return 0n;

			const priceAfterFixedTaxes =
			(typeof price === 'bigint' ? price : BigInt(price)) - fixedTaxes;

			return percentageTaxes > 0n
				? context.precisionService.adjustTaxFromScaledValue(
						priceAfterFixedTaxes,
						percentageTaxes,
						true
					).subtotal
				: priceAfterFixedTaxes;
		};
		const preservePriceType = (
			price: bigint | string | number
		): bigint | string | number => {
			const exclusivePrice = removeInclusiveTaxes(price);
			return typeof price === 'bigint'
				? exclusivePrice
				: typeof price === 'number'
					? Number(exclusivePrice)
					: exclusivePrice.toString();
		};

		return {
			...item,
			...(item.precio !== undefined && { precio: removeInclusiveTaxes(item.precio) }),
			...(item.precioBase !== undefined && {
				precioBase: preservePriceType(item.precioBase),
			}),
			...(item.specialPriceAmount !== undefined && {
				specialPriceAmount: removeInclusiveTaxes(item.specialPriceAmount),
			}),
			...(item.price !== undefined && { price: removeInclusiveTaxes(item.price) }),
			impuestos: item.impuestos?.map(tax =>
				tax.tipo === TaxEnum.Inclusive ? { ...tax, tipo: TaxEnum.Exclusive } : tax
			),
			productosCanal: item.productosCanal?.map(productChannel => ({
				...productChannel,
				precios: productChannel.precios?.map(price => ({
					...price,
					precio: removeInclusiveTaxes(price.precio),
					precioBase: removeInclusiveTaxes(price.precioBase),
					...(price.specialPriceAmount !== undefined &&
						price.specialPriceAmount !== null && {
							specialPriceAmount: removeInclusiveTaxes(price.specialPriceAmount),
						}),
					preciosEspeciales: price.preciosEspeciales?.map(specialPrice => ({
						...specialPrice,
						...(specialPrice.rangoFechaAsociado && {
							rangoFechaAsociado: {
								...specialPrice.rangoFechaAsociado,
								precio: removeInclusiveTaxes(
									specialPrice.rangoFechaAsociado.precio
								),
								precioBase: removeInclusiveTaxes(
									specialPrice.rangoFechaAsociado.precioBase
								),
							},
						}),
						diasAsociados: specialPrice.diasAsociados?.map(day => ({
							...day,
							precio: removeInclusiveTaxes(day.precio),
							precioBase: removeInclusiveTaxes(day.precioBase),
						})),
					})),
				})),
			})),
		};
	}),
});
